const mEditionBillingFiscalAuthorizer = {
  mEditionBillingFiscalAuthorizer: {
    action: 'Seleccionar',

    alerts: {
      updateAutorizadorFiscal: {
        activationSuccess: 'El autorizador fiscal fue activado exitosamente.',
        deactivationSuccess: 'El autorizador fiscal fue desactivado exitosamente.',
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.'
      }
    },

    table: {
      thName: 'Descripción',
      thMethod: 'Conectado',
      thActive: 'Estado',
      thEdit: 'Informacion',
      thDelete: 'Eliminar'
    },

    title: {
      first: 'Selecciona el autorizador fiscal que desa conectar',
      second: 'Autorizadores Fiscales conectados'
    },

    tooltip: {
      data: 'Ver Datos',
      edit: 'Ver autorizacion',
      delete: 'Eliminar Autorizacion Fiscal'
    }
  }
}

export default mEditionBillingFiscalAuthorizer
